<div class="public-auth-cta" [ngClass]="{'public-auth-cta--compact': compact}">
  <div class="public-auth-cta__copy">
    <strong>{{ titleKey | translate }}</strong>
    <span>{{ descriptionKey | translate }}</span>
  </div>

  <div class="public-auth-cta__actions" [class.public-auth-cta__actions--registration-first]="registrationPrimary">
    <ng-container *ngTemplateOutlet="registrationPrimary ? registrationButton : loginButton"></ng-container>
    <ng-container *ngTemplateOutlet="registrationPrimary ? loginButton : registrationButton"></ng-container>
  </div>

  <ng-template #loginButton>
    <button
      pButton
      type="button"
      class="p-button-sm p-button-rounded"
      [class.p-button-outlined]="registrationPrimary"
      (click)="goToLogin()"
      [label]="'auth.login.button.sign_in' | translate"
    ></button>
  </ng-template>
  <ng-template #registrationButton>
    <button
      pButton
      type="button"
      class="p-button-sm p-button-rounded"
      [class.p-button-outlined]="!registrationPrimary"
      (click)="goToRegister()"
      [label]="'auth.registration.button.register' | translate"
    ></button>
  </ng-template>
</div>
